import { USER_ROLE } from "Constants/constant";
import {
  insertFormTabChildrenAfterOther,
  isCustomFormCategory,
} from "components/DynamicForms/shared/formCategoryUtils";

export const CUSTOM_CRM_FORM_CATEGORY_TAB_ID_BASE = 50000;

export const customCrmFormCategoryTabId = (categoryId) =>
  CUSTOM_CRM_FORM_CATEGORY_TAB_ID_BASE + Number(categoryId);

export const isCustomCrmFormCategoryTabId = (tabId) =>
  Number(tabId) >= CUSTOM_CRM_FORM_CATEGORY_TAB_ID_BASE;

export const formCategoryTabFromCustomCategory = (category) => ({
  name: category.name,
  id: customCrmFormCategoryTabId(category.id),
  children: [],
  slug: category.slug,
  categoryUuid: category.uuid,
  isCustomFormCategory: true,
  roleAccess: [
    USER_ROLE.Sp_Admin,
    USER_ROLE.Sp_Standard_User,
    USER_ROLE.Sp_manager,
  ],
});

export const mergeCustomCrmCategoriesIntoFormsTab = (tabs, customCategories) => {
  if (!customCategories?.length) {
    return tabs;
  }

  const customChildren = customCategories
    .filter(isCustomFormCategory)
    .map(formCategoryTabFromCustomCategory);

  return tabs.map((tab) => {
    if (tab.id !== 4 || !tab.children?.length) {
      return tab;
    }

    const staticChildren = tab.children.filter((child) => !child.isCustomFormCategory);

    return {
      ...tab,
      children: insertFormTabChildrenAfterOther(staticChildren, 25, customChildren),
    };
  });
};
